import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { AgritoolComponent } from './agritool/agritool.component';
import { RegistrationComponent } from './registration/registration.component';
import { CropComponent } from './repository/crop/crop.component';
import { VarietyComponent } from './repository/variety/variety.component';
import { ProductComponent } from './repository/product/product.component';
import { MachineComponent } from './repository/machine/machine.component';
import { PagesLayoutComponent } from './Layout/pages-layout/pages-layout.component';
import { LoginComponent } from './authentication/login/login.component';
import { SignUpComponent } from './authentication/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { HealthLibraryComponent } from './health-library/health-library.component';
import { ProductsComponent } from './products/products.component';
import { MaintoolComponent } from './crophealth-tool/maintool/maintool.component';
import { AuthGuardService } from '../app/shared/services/authguard.service';
import { ProfileComponent } from './profile/profile.component';
import { CategoryComponent } from './repository/category/category.component';
import { PackingTypeComponent } from './transport/packing-type/packing-type.component';
import { SubTypeComponent } from './transport/sub-type/sub-type.component';
import { InternalTypeComponent } from './transport/internal-type/internal-type.component';
import { AddSubGroupComponent } from './e-commerce/add-sub-group/add-sub-group.component';
import { AddGroupComponent } from './e-commerce/add-group/add-group.component';
import { AddFormComponent } from './wfs/forms/add-form.component';
import { ClassesComponent } from './wfs/classes/classes.component';
import { ListComponent } from './wfs/list/list.component';
import { InputsComponent } from './repository/inputs/inputs.component';

const routes: Routes = [
  {
    path: 'home',
    component: BaseLayoutComponent,
    // canActivate: [AuthGuardService],
    children: [
      { path: '', component: AgritoolComponent, canActivate: [AuthGuardService],data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
      // { path: '', component: MaintoolComponent, data: { extraParameter: '', role: ['Admin', 'Super Admin', 'Reporting', 'Expert - Pathologist', 'Expert - Entomologist', 'Expert - Crop physiologist', 'Expert - Reviewer', 'Reporting'] } , runGuardsAndResolvers: 'always'},
      { path: 'register', component: RegistrationComponent, canActivate: [AuthGuardService], data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
      { path: 'repository/crop', component: CropComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'repository/variety', component: VarietyComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'repository/category', component: CategoryComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'repository/product', component: ProductComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'repository/machine', component: MachineComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'transport/packingType', component: PackingTypeComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'transport/subType', component: SubTypeComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'transport/internalType', component: InternalTypeComponent, canActivate: [AuthGuardService], data: { extraParameter: 'repositoryMenu', runGuardsAndResolvers: 'always' } },
      { path: 'health', component: HealthLibraryComponent, canActivate: [AuthGuardService], data: { extraParameter: '', } },
      { path: 'products', component: ProductsComponent, canActivate: [AuthGuardService], data: { extraParameter: '', } },
      { path: 'inputs', component: InputsComponent, canActivate: [AuthGuardService], data: { extraParameter: '', } },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthGuardService], data: { extraParameter: '', } },
       //E-commerce
    { path: 'addGroup', component: AddGroupComponent, canActivate: [AuthGuardService], data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
    { path: 'addSubGroup', component: AddSubGroupComponent, canActivate: [AuthGuardService], data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
    //WFS
    { path: 'forms', component: AddFormComponent, canActivate: [AuthGuardService], data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
    { path: 'classes', component: ClassesComponent, canActivate: [AuthGuardService], data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
    { path: 'list', component: ListComponent, canActivate: [AuthGuardService], data: { extraParameter: '', runGuardsAndResolvers: 'always' } },
    ]
  },
  {
    path: '',
    component: PagesLayoutComponent,
    children: [
      { path: '', component: LoginComponent, data: { extraParameter: '' } },
      { path: 'login', component: LoginComponent, data: { extraParameter: '' } },
      { path: 'signUp', component: SignUpComponent, data: { extraParameter: '' } },
      { path: 'forgotPassword', component: ForgotPasswordComponent, data: { extraParameter: '' } }
    ]
  },
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes,
//     {
//       scrollPositionRestoration: 'enabled',
//       anchorScrolling: 'enabled',
//       useHash: true
//     })],
//   exports: [RouterModule]
// })
@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}